import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type PollOfTheDayQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PollOfTheDayQuery = { __typename?: 'Query', viewerPollAndAnswer: { __typename?: 'PollAndAnswer', id: string, poll: { __typename?: 'Potd', id: string, value: string, date: string, options: Array<{ __typename?: 'PotdOption', id: string, potdId: string, value: string, responseCount: number }> }, answer: { __typename?: 'PotdAnswer', id: string, customerId: string, potdId: string, selectedOptions: Array<{ __typename?: 'PotdOption', id: string, potdId: string, value: string }> } | null } | null };

export type PollAndAnswerFragmentFragment = { __typename?: 'PollAndAnswer', id: string, poll: { __typename?: 'Potd', id: string, value: string, date: string, options: Array<{ __typename?: 'PotdOption', id: string, potdId: string, value: string, responseCount: number }> }, answer: { __typename?: 'PotdAnswer', id: string, customerId: string, potdId: string, selectedOptions: Array<{ __typename?: 'PotdOption', id: string, potdId: string, value: string }> } | null };

export type AnswerPollOfTheDayMutationVariables = Types.Exact<{
  answerIds: Array<Types.Scalars['ID']['input']>;
  potdId: Types.Scalars['ID']['input'];
}>;


export type AnswerPollOfTheDayMutation = { __typename?: 'Mutation', answerPollOfTheDay: { __typename?: 'PollAndAnswer', id: string, poll: { __typename?: 'Potd', id: string, value: string, date: string, options: Array<{ __typename?: 'PotdOption', id: string, potdId: string, value: string, responseCount: number }> }, answer: { __typename?: 'PotdAnswer', id: string, customerId: string, potdId: string, selectedOptions: Array<{ __typename?: 'PotdOption', id: string, potdId: string, value: string }> } | null } };

export type QuestionOfTheDayQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type QuestionOfTheDayQuery = { __typename?: 'Query', viewerQuestionAndAnswer: { __typename?: 'QuestionAndAnswer', id: string, question: { __typename?: 'Qotd', id: string, value: string, date: string, publicAnswers: { __typename?: 'QotdAnswerConnection', totalCount: number, nodes: Array<{ __typename?: 'QotdAnswer', id: string, value: string, author: { __typename?: 'QotdAnswerAuthor', id: string, nameFirst: string, nameLast: string, skipperType: Types.SkipperType | null } }> } }, answer: { __typename?: 'QotdAnswer', id: string, value: string, insight: { __typename?: 'Insight', status: Types.InsightStatus, value: string | null } | null, careerMatches: { __typename?: 'CareerMatches', status: Types.InsightStatus, value: Array<{ __typename?: 'CareerMatch', name: string, matchPercentage: number }> | null } | null } | null } | null, viewerCustomerCoachSummary: { __typename?: 'CoachSummaryResponse', coachSummary: { __typename?: 'CoachSummaryWithStatus', skipperType: Types.SkipperType | null, value: { __typename?: 'CoachSummary', skipperType: Types.SkipperType } | null } } };

export type AnswerQuestionOfTheDayMutationVariables = Types.Exact<{
  answer: Types.Scalars['String']['input'];
  qotdId: Types.Scalars['ID']['input'];
  isPublic: Types.Scalars['Boolean']['input'];
}>;


export type AnswerQuestionOfTheDayMutation = { __typename?: 'Mutation', answerQuestionOfTheDay: { __typename?: 'QuestionAndAnswer', id: string, question: { __typename?: 'Qotd', id: string, value: string, date: string, publicAnswers: { __typename?: 'QotdAnswerConnection', totalCount: number, nodes: Array<{ __typename?: 'QotdAnswer', id: string, value: string, author: { __typename?: 'QotdAnswerAuthor', id: string, nameFirst: string, nameLast: string, skipperType: Types.SkipperType | null } }> } }, answer: { __typename?: 'QotdAnswer', id: string, value: string, insight: { __typename?: 'Insight', status: Types.InsightStatus, value: string | null } | null, careerMatches: { __typename?: 'CareerMatches', status: Types.InsightStatus, value: Array<{ __typename?: 'CareerMatch', name: string, matchPercentage: number }> | null } | null } | null } };

export type QuestionAndAnswerFragmentFragment = { __typename?: 'QuestionAndAnswer', id: string, question: { __typename?: 'Qotd', id: string, value: string, date: string, publicAnswers: { __typename?: 'QotdAnswerConnection', totalCount: number, nodes: Array<{ __typename?: 'QotdAnswer', id: string, value: string, author: { __typename?: 'QotdAnswerAuthor', id: string, nameFirst: string, nameLast: string, skipperType: Types.SkipperType | null } }> } }, answer: { __typename?: 'QotdAnswer', id: string, value: string, insight: { __typename?: 'Insight', status: Types.InsightStatus, value: string | null } | null, careerMatches: { __typename?: 'CareerMatches', status: Types.InsightStatus, value: Array<{ __typename?: 'CareerMatch', name: string, matchPercentage: number }> | null } | null } | null };

export type GetSkipperTypeForSkipperTypeCardQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSkipperTypeForSkipperTypeCardQuery = { __typename?: 'Query', viewerCustomerCoachSummary: { __typename?: 'CoachSummaryResponse', coachSummary: { __typename?: 'CoachSummaryWithStatus', skipperType: Types.SkipperType | null, status: Types.CoachSummaryStatus, value: { __typename?: 'CoachSummary', skipperType: Types.SkipperType, strengths: Array<string> } | null } } };

export type TodoListDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TodoListDataQuery = { __typename?: 'Query', viewerQuestionAndAnswer: { __typename?: 'QuestionAndAnswer', id: string, answer: { __typename?: 'QotdAnswer', id: string, value: string } | null } | null, viewerPollAndAnswer: { __typename?: 'PollAndAnswer', id: string, answer: { __typename?: 'PotdAnswer', id: string, selectedOptions: Array<{ __typename?: 'PotdOption', id: string, value: string }> } | null } | null, viewerCustomerCoachSummary: { __typename?: 'CoachSummaryResponse', coachSummary: { __typename?: 'CoachSummaryWithStatus', skipperType: Types.SkipperType | null, value: { __typename?: 'CoachSummary', skipperType: Types.SkipperType } | null } } };

export type TopCareerMatchesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TopCareerMatchesQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, customerCareers: Array<{ __typename?: 'CustomerCareer', id: string, matchPercentage: number, career: { __typename?: 'Career', id: string, name: string, slug: string, description: string } }> } | null };

export type GetCurrentDashboardEnrollmentItemsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCurrentDashboardEnrollmentItemsQuery = { __typename?: 'Query', currentEnrollmentItemsOfType: Array<{ __typename?: 'EnrollmentItem', id: string, status: Types.EnrollmentStatus, programId: string }> };

export const PollAndAnswerFragmentFragmentDoc = gql`
    fragment PollAndAnswerFragment on PollAndAnswer {
  id
  poll {
    id
    value
    date
    options {
      id
      potdId
      value
      responseCount
    }
  }
  answer {
    id
    customerId
    potdId
    selectedOptions {
      id
      potdId
      value
    }
  }
}
    ` as unknown as DocumentNode<PollAndAnswerFragmentFragment, unknown>;
export const QuestionAndAnswerFragmentFragmentDoc = gql`
    fragment QuestionAndAnswerFragment on QuestionAndAnswer {
  id
  question {
    id
    value
    date
    publicAnswers(includeViewerResponse: false) {
      totalCount
      nodes {
        id
        value
        author {
          id
          nameFirst
          nameLast
          skipperType
        }
      }
    }
  }
  answer {
    id
    value
    insight {
      status
      value
    }
    careerMatches {
      status
      value {
        name
        matchPercentage
      }
    }
  }
}
    ` as unknown as DocumentNode<QuestionAndAnswerFragmentFragment, unknown>;
export const PollOfTheDayDocument = gql`
    query pollOfTheDay {
  viewerPollAndAnswer {
    ...PollAndAnswerFragment
  }
}
    ${PollAndAnswerFragmentFragmentDoc}` as unknown as DocumentNode<PollOfTheDayQuery, PollOfTheDayQueryVariables>;
export const AnswerPollOfTheDayDocument = gql`
    mutation answerPollOfTheDay($answerIds: [ID!]!, $potdId: ID!) {
  answerPollOfTheDay(answerIds: $answerIds, potdId: $potdId) {
    ...PollAndAnswerFragment
  }
}
    ${PollAndAnswerFragmentFragmentDoc}` as unknown as DocumentNode<AnswerPollOfTheDayMutation, AnswerPollOfTheDayMutationVariables>;
export const QuestionOfTheDayDocument = gql`
    query questionOfTheDay {
  viewerQuestionAndAnswer {
    ...QuestionAndAnswerFragment
  }
  viewerCustomerCoachSummary {
    coachSummary {
      skipperType
      value {
        skipperType
      }
    }
  }
}
    ${QuestionAndAnswerFragmentFragmentDoc}` as unknown as DocumentNode<QuestionOfTheDayQuery, QuestionOfTheDayQueryVariables>;
export const AnswerQuestionOfTheDayDocument = gql`
    mutation answerQuestionOfTheDay($answer: String!, $qotdId: ID!, $isPublic: Boolean!) {
  answerQuestionOfTheDay(answer: $answer, qotdId: $qotdId, isPublic: $isPublic) {
    ...QuestionAndAnswerFragment
  }
}
    ${QuestionAndAnswerFragmentFragmentDoc}` as unknown as DocumentNode<AnswerQuestionOfTheDayMutation, AnswerQuestionOfTheDayMutationVariables>;
export const GetSkipperTypeForSkipperTypeCardDocument = gql`
    query getSkipperTypeForSkipperTypeCard {
  viewerCustomerCoachSummary {
    coachSummary {
      skipperType
      status
      value {
        skipperType
        strengths
      }
    }
  }
}
    ` as unknown as DocumentNode<GetSkipperTypeForSkipperTypeCardQuery, GetSkipperTypeForSkipperTypeCardQueryVariables>;
export const TodoListDataDocument = gql`
    query todoListData {
  viewerQuestionAndAnswer {
    id
    answer {
      id
      value
    }
  }
  viewerPollAndAnswer {
    id
    answer {
      id
      selectedOptions {
        id
        value
      }
    }
  }
  viewerCustomerCoachSummary {
    coachSummary {
      skipperType
      value {
        skipperType
      }
    }
  }
}
    ` as unknown as DocumentNode<TodoListDataQuery, TodoListDataQueryVariables>;
export const TopCareerMatchesDocument = gql`
    query topCareerMatches {
  viewerCustomer {
    id
    customerCareers(sort: [matchPercentage_desc, matchDate_desc]) {
      id
      career {
        id
        name
        slug
        description
      }
      matchPercentage
    }
  }
}
    ` as unknown as DocumentNode<TopCareerMatchesQuery, TopCareerMatchesQueryVariables>;
export const GetCurrentDashboardEnrollmentItemsDocument = gql`
    query getCurrentDashboardEnrollmentItems($customerId: ID!) {
  currentEnrollmentItemsOfType(customerId: $customerId, type: SCHOOL) {
    id
    status
    programId
  }
}
    ` as unknown as DocumentNode<GetCurrentDashboardEnrollmentItemsQuery, GetCurrentDashboardEnrollmentItemsQueryVariables>;